import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['ar', 'en'],
  defaultLocale: 'ar',
  localePrefix: 'as-needed',
  localeDetection: false, // Root (/) always serves Arabic; use LanguageSwitcher to switch
  // Disable automatic Link headers — hreflang alternates are already generated
  // via generateMetadata in each layout, preventing duplicate/large response headers.
  alternateLinks: false,
});
